module.exports = __webpack_public_path__ + "img/ring_g_c_null_null@2x.0c6e6cf9.png";